// extracted by mini-css-extract-plugin
export default {"thumb-root":"HotelListCardThumb_thumb-root__UM0Wa","sticker":"HotelListCardThumb_sticker__ef7zi","fancy-box-open-btn":"HotelListCardThumb_fancy-box-open-btn__Wa5bg"};